import React, { Component} from "react";
import { Container ,Row,UncontrolledDropdown ,DropdownToggle,DropdownMenu,DropdownItem,FormGroup,Input,Label, Form} from "reactstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faSearch} from '@fortawesome/free-solid-svg-icons'
import { withRouter } from "react-router-dom";
import {connect } from 'react-redux';

class AdvancedSearchLocation extends Component {
  constructor(props) {
    super(props);
    this.state= {
      region : "",
      pays : "Algerie",
      dateDebut : "" ,
      dateFin :"",
      chauffeur : "Avec Chaufeur",
      restitution : "",
      conducteur : ""
    }
    this.onFormSubmit = this.onFormSubmit.bind(this);
  }
  onInputChange(evt) {
    this.setState({
      [evt.target.name]: evt.target.value
    })
  }

  onFormSubmit(evt) {
    evt.preventDefault()
    const {region,dateDebut,dateFin} = this.state
    this.props.history.push(`/cars/location/advanced_search?region=${region}&date_debut=${dateDebut}&date_fin=${dateFin}`);
  }
  changeState(e){
    this.setState({
      [e.target.name]: e.target.value
    })
  }

  render(){

    return (
      <Container>
        <Form onChange={e=>this.onInputChange(e)} onSubmit={this.onFormSubmit.bind(this)} >
          <Row className="d-flex justify-contnet-between mx-0">
            <UncontrolledDropdown className="col-12 col-sm-6 col-lg-3 mb-2 mb-lg-3 pr-0" nav inNavbar>
              <input type="text"  name="region" className="filter-element left-radius" placeholder=" Lieu de ramassage" required />
            </UncontrolledDropdown>


            <UncontrolledDropdown className="col-12 col-sm-6 col-lg-3 mb-2 mb-lg-3 p-0">
              <DropdownToggle id="destination" className="filter-element rounded-0" style={{ width: "100%", backgroundColor: "white", color: "#37296a", textAlign: "left", fontWeight: "bold" }}>
                <img src="/imgs/navebar/downArrow.svg" alt="" id="arrow-parcourir-big" />
                {this.state.chauffeur}
              </DropdownToggle>
              <DropdownMenu left className="full-width">
                <DropdownItem name="chauffeur" value={"avec chaufeur"} onClick={e => this.changeState(e)} >Avec Chaufeur</DropdownItem>
                <DropdownItem name="chauffeur" value={"sans chaufeur"} onClick={e => this.changeState(e)} >Sans Chaufeur</DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>


            <div className="col-6 col-sm-4 col-lg-2 mb-2 mb-lg-3 px-0">
              <Input
                className="filter-element rounded-0"
                placeholder="Date début"
                name="dateDebut"
                type="text"
                required
                onFocus={(e) => {
                  e.target.type = "date";
                }}
              />
            </div>
            <div className="dropdowns col-6 col-sm-4 col-lg-2 mb-0 mb-lg-3 pl-0">
              <Input
                className="filter-element right-radius"
                type="text"
                name="dateFin"
                placeholder="Date fin"
                required
                onFocus={(e) => {
                  e.target.type = "date";
                }}
              />
            </div>

            <UncontrolledDropdown
              className="dropdowns col-12 col-sm-4 col-lg-2 mb-0 mb-lg-3 px-1"
              nav
              inNavbar
            >
              <DropdownToggle
                type="submit"
                id="recherche-button"
                style={{
                  width: "100%",
                  backgroundColor: "#37296a",
                  color: "white",
                  textAlign: "left",
                  fontWeight: "bold",
                  fontSize: "13px",
                  height: "36px",
                }}
              >
                Recherche
                <FontAwesomeIcon id="recherche" icon={faSearch} />
              </DropdownToggle>
            </UncontrolledDropdown>
          </Row>
          <Row className="ml-1 mt-1 d-block d-sm-flex justify-content-start">
            <FormGroup className="col-12 col-sm-6 col-md-4 col-lg-3" check>
              <Input type="checkbox" name="check" id="exampleCheck1" />
              <Label for="exampleCheck1" check>
                Restituer dans un endroit différent
              </Label>
            </FormGroup>
            <FormGroup className="col-12 col-sm col-md col-lg" check>
              <Input type="checkbox" name="check" id="exampleCheck" />
              <Label for="exampleCheck" check>
                Conducteur entre 30 et 60 ans
              </Label>
            </FormGroup>
          </Row>
        </Form>
      </Container>
    );
  }
}

function mapStateToProps(state) {
  return {}
}
export default withRouter(connect(mapStateToProps)(AdvancedSearchLocation));